<template>
  <div class="notice-detail">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item  @click.native="goBack">公告列表</el-breadcrumb-item>
      <el-breadcrumb-item>信息详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="newestNoticSty">
      <div style="padding: 30px 30px;">
        <div class="backup" @click="goBack">
          <img src="@/assets/image/back-img.png" alt=""/>
          <span>返回列表</span>
        </div>
        <div class="title">
          {{ noticeDetails.title }}
        </div>
        <p class="time">发布时间：{{ noticeDetails.createTime }}</p>
        <el-divider></el-divider>
        <div class="v-html-custom-wrapper">
          <div v-html="noticeDetails.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  noticeDetails
} from "@/api/index.js"

export default {
  data() {
    return {
      noticeDetails: {}
    }
  },
  methods: {
    getInfo() {
      let param = {
        id: this.$route.query.id
      }
      noticeDetails(param).then(res => {
        if (res.code == "0000") {
          // console.log(res.data)
          this.noticeDetails = res.data
        }
      })
    },
    goBack() {
        this.$router.go(-1);
    }
  },
  mounted() {
    this.getInfo()
  }
}
</script>

<style lang="scss" scoped>
.notice-detail{
  margin: 0 auto;
  width: 1200px;
}
.page-breadcrumb {
  margin: 15px 0;
  padding: 10px 16px;
  background: #fafafa;
  border-radius: 4px;
  cursor: pointer;
}

.newestNoticSty {
  width: 1200px;
  min-height: 70vh;
  background-color: #FFFFFF;
  margin: 0 auto;
  border-radius: 4px;
  box-shadow: 10px 10px 5px #cccccc;

  .title {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    line-height: 50px;
    margin-bottom: 10px;
  }

  .time {
    text-align: center;
    font-size: 16px;
    color: #808080;
    line-height: 30px;
  }

}

.backup {
  display: flex;
  cursor: pointer;
  justify-content: end;

  img {
    width: 16px;
    height: 15px;
  }

  span {
    margin-left: 5px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #0668f9;
    line-height: 16px;
    text-align: justify;
    font-style: normal;
  }
}

</style>

<style scoped>
/* 核心：将原body的全局样式，应用到v-html容器内的所有元素 */
.v-html-custom-wrapper >>> * {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
  line-height: 1.7; /* 继承原body的行高 */
  box-sizing: border-box; /* 补充：避免盒模型问题 */
  text-align: left;
}

/* v-html容器本身：模拟原body的max-width、居中、内边距 */
.v-html-custom-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

/* 标题样式（完全复用你提供的样式） */
.v-html-custom-wrapper >>> h1 {
  margin-bottom: 16px;
  font-weight: 600;
  text-align: center;
  font-size: 24px;
}
.v-html-custom-wrapper >>> h2,
.v-html-custom-wrapper >>> h3,
.v-html-custom-wrapper >>> h4,
.v-html-custom-wrapper >>> h5,
.v-html-custom-wrapper >>> h6 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: 600;
}

/* 段落样式 */
.v-html-custom-wrapper >>> p {
  margin-bottom: 16px;
}

/* 单行代码样式 */
.v-html-custom-wrapper >>> code {
  background: #f6f8fa;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}

/* 多行代码块样式 */
.v-html-custom-wrapper >>> pre {
  background: #f6f8fa;
  padding: 16px;
  border-radius: 6px;
  overflow-x: auto;
}

/* 引用样式 */
.v-html-custom-wrapper >>> blockquote {
  border-left: 4px solid #dfe2e5;
  padding-left: 16px;
  margin: 0 0 16px 0;
  color: #6a737d;
}

/* 表格样式 */
.v-html-custom-wrapper >>> table {
  border-collapse: collapse;
  width: 100%;
}

.v-html-custom-wrapper >>> th,
.v-html-custom-wrapper >>> td {
  border: 1px solid #dfe2e5;
  padding: 8px 12px;
  text-align: left;
}

.v-html-custom-wrapper >>> th {
  background: #f6f8fa;
  font-weight: 600;
}

/* 列表样式（ul/ol/li），匹配整体风格 */
.v-html-custom-wrapper >>> ul {
  margin-bottom: 16px;
  padding-left: 24px; /* 预留标记显示空间 */
  list-style-type: disc; /* 无序列表显示实心圆点 */
  list-style-position: outside; /* 标记在列表项外部（默认，更美观） */
}
.v-html-custom-wrapper >>> ol {
  margin-bottom: 16px;
  padding-left: 24px;
  list-style-type: decimal; /* 有序列表显示数字 */
  list-style-position: outside;
}
.v-html-custom-wrapper >>> li {
  margin-bottom: 8px;
  /* 避免li继承全局样式导致标记隐藏 */
  list-style: inherit;
}
/* 嵌套列表：区分标记样式，视觉层级更清晰 */
.v-html-custom-wrapper >>> li ul {
  margin-top: 8px;
  margin-bottom: 0;
  padding-left: 20px;
  list-style-type: circle; /* 嵌套无序列表显示空心圆点 */
}
.v-html-custom-wrapper >>> li ol {
  margin-top: 8px;
  margin-bottom: 0;
  padding-left: 20px;
  list-style-type: lower-alpha; /* 嵌套有序列表显示小写字母 */
}

</style>


